<template>
<div id="chat_intro">

	<div class="caption">
		<span>{{$t('snippity.chatIntroMessage')}}</span>
	</div>

    <div class="profilewrapper" v-if="userinfo">
        <userpic :userinfo="userinfo"/>
    </div>

	<div class="logowrapper">
        <logotype />
    </div>
</div>
</template>

<style scoped lang="sass">

#chat_intro
	display: flex
	flex-flow: column
	justify-content: center
	align-items: center

	.caption
		text-align: center
		max-width: 300px
		color : srgb(--neutral-grad-4)

		span
			font-size: 1.5em
			font-weight: 700

	.profilewrapper
		margin-top: 2 * $r

		.userpic
			width: 88px
			height: 88px
			line-height: 88px
            
			+shadowSmaller()

			::v-deep
				.charAvatar,
				.statusIcon
					font-size: 1em

	.logowrapper
		margin-top: 2 * $r

</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'chat_intro',
	props: {
	},
	computed: mapState({
		auth: state => state.auth,
		userinfo: state => state.userinfo
	}),

	methods: {

	},
}
</script>
